import { render, staticRenderFns } from "./main2.vue?vue&type=template&id=20058ddd"
import script from "./main2.vue?vue&type=script&lang=js"
export * from "./main2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports